import Iconify from '@iconify/iconify'

export default Iconify



//////////////////
// WEBPACK FOOTER
// ./node_modules/@purge-icons/generated/index.mjs
// module id = TQHl
// module chunks = 21